import React from 'react';

interface SSOIconProps {
  color?: string;
}

export const SSOIcon: React.FC<SSOIconProps> = ({ color }) => {
  // Use currentColor by default to inherit from parent, or explicit color if provided
  const iconColor = color || 'currentColor';

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M14.3994 4.2998C17.3251 4.2998 19.7001 6.67396 19.7002 9.59961C19.7002 12.5254 17.3252 14.8994 14.3994 14.8994C13.8723 14.8994 13.3786 14.8117 12.9141 14.6719L11.873 15.7129C11.7793 15.8067 11.6521 15.8594 11.5195 15.8594H10.0996V17.2803C10.0994 17.5562 9.8756 17.7803 9.59961 17.7803H8.17969V19.2002C8.17948 19.4762 7.9557 19.7002 7.67969 19.7002H4.7998C4.52379 19.7002 4.30002 19.4762 4.2998 19.2002V16.3193C4.29993 16.1869 4.35263 16.0595 4.44629 15.9658L9.32617 11.085C9.1865 10.6206 9.09961 10.1265 9.09961 9.59961C9.09972 6.67409 11.4739 4.30002 14.3994 4.2998ZM15.3604 7.2002C14.5651 7.2002 13.9199 7.84533 13.9199 8.64062C13.9202 9.43572 14.5652 10.0801 15.3604 10.0801C16.1553 10.0798 16.7996 9.43557 16.7998 8.64062C16.7998 7.84548 16.1554 7.20043 15.3604 7.2002Z"
        fill={iconColor}
      />
    </svg>
  );
};
